let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ei0Jg")).then(() => parcelRequire('esrJ1'));